// Данные пока захардкожены на основе резюме.
// TODO: status/stats будут подтягиваться из GitHub API веб-сервером — сейчас это mock-данные для теста вёрстки.
// TODO: readme в будущем будет подтягиваться из README.md репозитория.

export const projects = [
  {
    slug: 'nodal',
    name: 'nodal',
    category: 'mobile',
    description:
      'Кроссплатформенное приложение для Android и iOS, которое считает и визуализирует полиномиальную интерполяцию по таблице точек — от классического Лагранжа до Бесселя.',
    features: [
      'Реализовано семь методов интерполяции (Лагранж, Ньютон вперёд/назад, Гаусс вперёд/назад, Стирлинг, Бессель), каждый — с корректной классической трактовкой опорных узлов.',
      'Архитектура разложена по слоям domain / presentation / di, с паттернами CanSolve и Visitor и единым MainStore для состояния.',
      'На графике все методы отрисовываются одновременно, с возможностью включать и выключать отдельные кривые.',
      'Вычисления идут через BigDecimal — точность можно настраивать вручную.',
    ],
    stack: ['Compose Multiplatform', 'Voyager', 'Koin', 'MVVM + UDF', 'kotlin-bignum'],
    github: 'ProtosKey/nodal',
    status: 'active',
    stats: { stars: 3, lastCommit: '2026-08-02', language: 'Kotlin' },
    readme: `## Возможности

- Реализовано семь методов интерполяции: Лагранж, Ньютон вперёд/назад, Гаусс вперёд/назад, Стирлинг, Бессель — каждый с корректной классической трактовкой опорных узлов.
- На графике все методы отрисовываются одновременно, отдельные кривые можно включать и выключать.
- Точность настраивается вручную — все вычисления идут через \`BigDecimal\`.

## Архитектура

Слои \`domain\` / \`presentation\` / \`di\`, паттерны **CanSolve** и **Visitor**, единое состояние через \`MainStore\`.`,
  },
  {
    slug: 'diff',
    name: 'diff',
    category: 'mobile',
    description:
      'Кроссплатформенный солвер для Android и iOS, который численно решает задачу Коши для ОДУ первого порядка тремя разными методами и сравнивает их точность в реальном времени.',
    features: [
      'Поддерживаются усовершенствованный метод Эйлера, Рунге–Кутта 4-го порядка и метод Милна, точность контролируется по правилу Рунге с единым критерием для всех трёх.',
      'Отдельно продумана защита от переполнений — приложение корректно считает даже там, где значения разрастаются до порядка 10⁴³.',
      'График поддерживает pan/zoom и сам подстраивает диапазон по Y для быстрорастущих решений.',
      'Таблицы вычислений виртуализированы, чтобы не тормозить на больших наборах точек.',
    ],
    stack: ['Compose Multiplatform', 'Voyager', 'Koin', 'MVVM + UDF', 'StateFlow', 'Coroutines'],
    github: 'ProtosKey/diff',
    status: 'active',
    stats: { stars: 2, lastCommit: '2026-07-21', language: 'Kotlin' },
    readme: `## Возможности

- Усовершенствованный метод Эйлера, Рунге–Кутта 4-го порядка и метод Милна — точность контролируется по правилу Рунге с единым критерием для всех трёх.
- Защита от переполнений: приложение корректно считает даже там, где значения разрастаются до порядка \`10^43\`.
- График с pan/zoom сам подстраивает диапазон по Y для быстрорастущих решений.
- Таблицы вычислений виртуализированы — не тормозят на больших наборах точек.`,
  },
  {
    slug: 'proxima',
    name: 'proxima',
    category: 'mobile',
    description:
      'Мобильное приложение для Android и iOS, которое подбирает функцию, лучше всего описывающую введённые точки, и сразу показывает её в виде LaTeX-формулы.',
    features: [
      'Перебирается шесть моделей — линейная, квадратичная, кубическая, экспоненциальная, логарифмическая, показательная — лучшая выбирается автоматически по коэффициенту детерминации R².',
      'Формулы рендерятся в LaTeX, график строится в реальном времени.',
      'Готовый результат можно сразу скопировать в буфер обмена.',
      'Все вычисления идут через BigDecimal, чтобы не терять точность.',
    ],
    stack: ['Compose Multiplatform', 'Voyager', 'MVVM + UDF', 'BigDecimal'],
    github: 'ProtosKey/proxima',
    status: 'active',
    stats: { stars: 1, lastCommit: '2026-06-15', language: 'Kotlin' },
    readme: `## Возможности

- Перебираются шесть моделей — линейная, квадратичная, кубическая, экспоненциальная, логарифмическая, показательная — лучшая выбирается автоматически по коэффициенту детерминации **R²**.
- Формулы рендерятся в LaTeX, график строится в реальном времени.
- Результат копируется в буфер обмена одним нажатием.
- Все вычисления идут через \`BigDecimal\`, чтобы не терять точность.`,
  },
  {
    slug: 'velosiped',
    name: 'velosiped',
    category: 'systems',
    description:
      'Своя система контроля версий (vls), написанная с нуля на чистом C23 поверх низкоуровневых системных вызовов POSIX — без готовых библиотек, только файлы, дескрипторы и хеши.',
    features: [
      'Хранилище устроено как content-addressed и append-only: файлы адресуются по MD5-хешу через OpenSSL EVP API, история коммитов — односвязный список, где каждый коммит хранит хеш родителя.',
      'Поддержан весь базовый цикл — init, add, status, commit, reset, drop, log.',
      'При commit удалённые файлы автоматически помечаются как DELETED, без отдельной команды rm.',
      'Тесты собраны через CTest.',
    ],
    stack: ['C23', 'POSIX', 'OpenSSL EVP API', 'CMake', 'CTest', 'cJSON'],
    github: 'ProtosKey/velosiped',
    status: 'active',
    stats: { stars: 4, lastCommit: '2026-08-28', language: 'C' },
    readme: `## Возможности

- Хранилище content-addressed и append-only: файлы адресуются по MD5-хешу через \`OpenSSL EVP API\`.
- История коммитов — односвязный список, каждый коммит хранит хеш родителя.
- Поддержан весь базовый цикл: \`init\`, \`add\`, \`status\`, \`commit\`, \`reset\`, \`drop\`, \`log\`.
- При \`commit\` удалённые файлы автоматически помечаются как \`DELETED\`, без отдельной команды \`rm\`.

## Архитектура

Никаких готовых библиотек — только файлы, дескрипторы и системные вызовы POSIX напрямую. Тесты собраны через \`CTest\`.`,
  },
  {
    slug: 'aka_lab4',
    name: 'aka_lab4',
    category: 'systems',
    description:
      'Учебный проект по архитектуре ЭВМ на два фронта: транслятор минимального диалекта Lisp в машинный код и цикл-точный симулятор RISC-V-подобного процессора с микропрограммным управлением.',
    features: [
      'Транслятор проходит полный путь от лексера и AST-парсера до двухпроходного ассемблера и генерации кода.',
      'Процессор — RV32I-подобный набор команд, где каждая инструкция честно занимает 2–3 такта, а управляется всё через Control Unit на ROM из 31 микроинструкции, с гарвардской архитектурой памяти и потоковым портовым вводом-выводом.',
      'Корректность проверяется 50 golden-тестами — сверяются вывод, листинг, тик-трейс и покрытие набора команд, всё через pytest и CI на GitHub Actions.',
    ],
    stack: ['Python', 'RISC-V (RV32I-подобный)', 'pytest', 'GitHub Actions'],
    github: 'ProtosKey/aka_lab4',
    status: 'done',
    stats: { stars: 2, lastCommit: '2026-05-10', language: 'Python' },
    readme: `## Возможности

- Транслятор проходит полный путь от лексера и AST-парсера до двухпроходного ассемблера и генерации кода.
- Процессор — RV32I-подобный набор команд, каждая инструкция занимает 2–3 такта.
- Управление через **Control Unit** на ROM из 31 микроинструкции, гарвардская архитектура памяти, потоковый портовый ввод-вывод.
- Корректность проверяется 50 golden-тестами: вывод, листинг, тик-трейс и покрытие набора команд — всё через \`pytest\` и CI на GitHub Actions.`,
  },
  {
    slug: 'aka_lab3',
    name: 'aka_lab3',
    category: 'systems',
    description:
      'Набор из четырёх лабораторных программ, каждая — на своей архитектуре ассемблера, от аккумуляторной до RISC-подобной.',
    features: [
      'Реверс C-строки написан под аккумуляторную acc32.',
      'Подсчёт конечных нулей числа — под стековую f32a.',
      'Форматирование строки — под CISC-архитектуру m68k.',
      'Сумма нечётных чисел меньше n — под RISC-V-подобную risc-iv.',
      'Всё выполнено на учебной платформе Wrench.',
    ],
    stack: ['Assembly (acc32, f32a, m68k, RISC-V)', 'Wrench'],
    github: 'ProtosKey/aka_lab3',
    status: 'done',
    stats: { stars: 1, lastCommit: '2026-04-02', language: 'Assembly' },
    readme: `## Возможности

- Реверс C-строки — под аккумуляторную архитектуру \`acc32\`.
- Подсчёт конечных нулей числа — под стековую \`f32a\`.
- Форматирование строки — под CISC-архитектуру \`m68k\`.
- Сумма нечётных чисел меньше n — под RISC-V-подобную \`risc-iv\`.

Всё выполнено на учебной платформе **Wrench**.`,
  },
  {
    slug: 'calc_lab3',
    name: 'calc_lab3',
    category: 'other',
    description:
      'Десктопный калькулятор для численного интегрирования методами прямоугольников, трапеций и Симпсона.',
    stack: ['Kotlin', 'Compose Multiplatform', 'Gradle'],
    github: 'ProtosKey/calc_lab3',
    status: 'done',
    stats: { stars: 0, lastCommit: '2026-03-18', language: 'Kotlin' },
  },
  {
    slug: 'java_lab7',
    name: 'java_lab7',
    category: 'other',
    description:
      'Менеджер учебных групп: клиент-серверное приложение с аутентификацией и хранением данных в PostgreSQL.',
    stack: ['Java', 'TCP', 'PostgreSQL', 'Gradle'],
    github: 'ProtosKey/java_lab7',
    status: 'done',
    stats: { stars: 0, lastCommit: '2026-02-24', language: 'Java' },
  },
  {
    slug: 'web_lab4',
    name: 'web_lab4',
    category: 'other',
    description:
      'Веб-приложение для проверки попадания точки в область под графиком, с аутентификацией и совместной работой.',
    stack: ['Java', 'WildFly', 'React + Redux', 'PostgreSQL'],
    github: 'ProtosKey/web_lab4',
    status: 'done',
    stats: { stars: 1, lastCommit: '2026-02-02', language: 'Java' },
  },
  {
    slug: 'java_lab3',
    name: 'java_lab3',
    category: 'other',
    description:
      'Консольная симуляция битвы нескольких команд на корабле с уникальными характеристиками персонажей.',
    stack: ['Java'],
    github: 'ProtosKey/java_lab3',
    status: 'done',
    stats: { stars: 0, lastCommit: '2026-01-14', language: 'Java' },
  },
  {
    slug: 'calc_lab1',
    name: 'calc_lab1',
    category: 'other',
    description: 'Решение систем линейных уравнений методом Гаусса в консоли.',
    stack: ['Java', 'Gradle'],
    github: 'ProtosKey/calc_lab1',
    status: 'done',
    stats: { stars: 0, lastCommit: '2025-12-20', language: 'Java' },
  },
];

export function getProjectBySlug(slug) {
  return projects.find((p) => p.slug === slug);
}
